<template>
  <div class="home">
    <div class="wrapper-content registerHeader marginhide">
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>{{ $t('message.AddAddress') }}</h2>
        </div>
      </div>
      <div class="profile-edit-photo" v-if="isEdit">
        <div class="round-profile">
          <img src="../assets/images/download.png" alt="user-img" />
        </div>
      </div>
      <div class="addmoney newaddress">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2">
              <div class="add-newaddresss panel">
                <div class="input-animation">
                  <form @submit.prevent="saveDetails">
                    <div class="input-field">
                      <input type="text" id="house" v-model="houseNo" />
                      <label for="house">{{ $t('message.HouseNumber') }}</label>
                    </div>
                    <div
                      class="error"
                      v-if="!houseNo && submitStatus"
                    >{{ $t('message.HouseNumberValidation') }}</div>

                    <div class="input-field" v-if="!isEdit">
                      <input type="text" id="Street" v-model="street" />
                      <label for="street">{{ $t('message.Street') }}</label>
                    </div>

                    <div class="input-field">
                      <input type="text" id="city" v-model="city" />
                      <label for="city">{{ $t('message.City') }}</label>
                    </div>
                    <div
                      class="error"
                      v-if="!city && submitStatus"
                    >{{ $t('message.CityValidation') }}</div>

                    <div class="input-field">
                      <input type="text" id="state" v-model="state" />
                      <label for="state">{{ $t('message.State') }}</label>
                    </div>
                    <div
                      class="error"
                      v-if="!state && submitStatus"
                    >{{ $t('message.StateValidation') }}</div>

                    <div class="input-field">
                      <input type="text" id="land" v-model="landmark" />
                      <label for="land">{{ $t('message.Landmark') }}</label>
                    </div>

                    <div class="input-field">
                      <label>{{ $t('message.Nickname') }}</label>
                      <br />
                      <br />
                      <b-form-radio-group
                        id="btn-radios-2"
                        v-model="selectedTitle"
                        :options="options"
                        buttons
                        button-variant="outline-dark"
                        size="lg"
                        name="radio-btn-outline"
                      ></b-form-radio-group>
                    </div>
                    <div
                      class="error"
                      v-if="!selectedTitle && submitStatus"
                    >{{ $t('message.NicknameValidation') }}</div>

                    <button
                      class="submit-btn"
                      type="submit"
                      v-on:click="saveDetails"
                    >{{ $t('message.Save') }} {{ $t('message.And') }} {{ $t('message.Proceed') }}</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { registerProfile } from "./../services/api";
import VueGeolocation from "vue-browser-geolocation";
import Vuelidate from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import myUpload from "vue-image-crop-upload";

Vue.use(Vuelidate);

const axios = require("axios");
Vue.use(VueGeolocation);
export default {
  name: "home",
  components: {
    myUpload
  },
  validations: {
    state: {
      required
    },
    city: {
      required
    },
    houseNo: {
      required
    },
    selectedTitle: {
      required
    }
  },
  data() {
    return {
      show: false,
      imageBaseUrl: "https://trakop.s3.amazonaws.com/",
      lat: "",
      long: "",
      address: "",
      image: "",
      addressTitle: "",
      key: "AIzaSyBmS9QQWofTpIbYDpWebbUP9lhbBBW5raA",
      name: "",
      email: "",
      street: "",
      locality: "",
      state: "",
      city: "",
      zipCode: "",
      houseNo: "",
      landmark: "",
      center: {
        lat: "",
        lng: ""
      },
      file: [],
      markers: [],
      places: [],
      currentPlace: null,
      options: [
        { text: "Home", value: "home" },
        { text: "Work", value: "work" },
        { text: "Others", value: "other" }
      ],
      selectedTitle: "",
      submitStatus: false,
      isEdit: window.location.href.includes("edit-profile"),
      addresses: []
    };
  },

  methods: {
    toggleShow() {
      this.show = !this.show;
    },

    saveDetails() {
      if (this.$v.$invalid) {
        this.submitStatus = true;
      } else {
        console.log("*****");
        var hno;
        if (this.street) {
          hno = this.houseNo + "," + this.street;
        } else {
          hno = this.houseNo;
        }

        var adGiven = {
          address: hno,
          landMark: this.landmark,
          state: this.state,
          title: this.selectedTitle,
          city: this.city,
          lat: this.center.lat,
          long: this.center.lng
        };
        console.log("*****", adGiven);
        localStorage.setItem("newAddress", JSON.stringify(adGiven));

        this.$router.push({ name: "location", query: { addNew: true } });
      }
    }
  }
};
</script>
<style lang="scss">
@import "../assets/css/custom.scss";
</style>